const React = require('react');
const PropTypes = require('prop-types');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');


const DataTable = ({ data, children, onMouseEnterRow, onClickRow, returnIndex }) => (
    <OKTable className="data-table">
        <thead className="data-table__head">
            <OKTableRow asHeader>
                {
                    React.Children.map(children, (tc, i) => (
                        <OKTableCell asHeader key={i} className={tc.props.className}>
                            {tc && tc.props ? tc.props.header : ''}
                        </OKTableCell>
                    ))
                }
            </OKTableRow>
        </thead>
        <tbody className="data-table__body">
            {data &&
                data.map((d, i) => (
                    <OKTableRow
                        key={i}
                        onMouseEnter={() => onMouseEnterRow && onMouseEnterRow(returnIndex ? i : d)}
                        onClick={() => onClickRow && onClickRow(returnIndex ? i : d)}
                    >
                        {
                            React.Children.map(children, (tc, j) => (
                                <OKTableCell key={j}>
                                    {tc
                                    ?

                                        tc.props.format
                                        ? tc.props.format(data[i][tc.props.dataKey], i)
                                        : data[i][tc.props.dataKey]

                                    :
                                    ''}
                                </OKTableCell>
                            ))
                        }
                    </OKTableRow>
                ))
            }
        </tbody>
    </OKTable>
);


DataTable.defaultProps = {
    returnIndex: false,
};

DataTable.propTypes = {
    children: PropTypes.node.isRequired,
    data: PropTypes.array.isRequired,
    onClickRow: PropTypes.func,
    onMouseEnterRow: PropTypes.func,
    returnIndex: PropTypes.bool,
};


module.exports = DataTable;
